import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogCategories from "./pages/BlogCategories";
import Videos from "./pages/Videos";
import Resources from "./pages/Resources";
import Advertise from "./pages/Advertise";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Unsubscribe from "./pages/Unsubscribe";
import BlogPost from "./pages/BlogPost";
import Bookmarks from "./pages/Bookmarks";
import AccidentChecklist from "./pages/AccidentChecklist";
import LegalDirectory from "./pages/LegalDirectory";
import SafetyStatistics from "./pages/SafetyStatistics";
import FAQ from "./pages/FAQ";
import SafetyQuiz from "./pages/SafetyQuiz";
import Partners from "./pages/Partners";
import Sponsorship from "./pages/Sponsorship";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { BookmarksProvider } from "./contexts/BookmarksContext";
import { initAnalytics } from "./utils/analytics";

function App() {
  useEffect(() => {
    // Initialize analytics tracking
    initAnalytics();
  }, []);

  return (
    <ThemeProvider>
      <BookmarksProvider>
        <AuthProvider>
          <div className="App">
            <BrowserRouter>
              <Header />
              <main>
                <Routes>
                  {/* Public routes */}
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/categories" element={<BlogCategories />} />
                  <Route path="/videos" element={<Videos />} />
                  <Route path="/resources" element={<Resources />} />
                  <Route path="/advertise" element={<Advertise />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="/unsubscribe" element={<Unsubscribe />} />
                  <Route path="/blog/:postId" element={<BlogPost />} />
                  <Route path="/bookmarks" element={<Bookmarks />} />
                  <Route path="/accident-checklist" element={<AccidentChecklist />} />
                  <Route path="/legal-directory" element={<LegalDirectory />} />
                  <Route path="/safety-statistics" element={<SafetyStatistics />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/quiz" element={<SafetyQuiz />} />
                  <Route path="/quiz/:quizId" element={<SafetyQuiz />} />
                  <Route path="/partners" element={<Partners />} />
                  <Route path="/sponsorship" element={<Sponsorship />} />
                  
                  {/* Admin routes */}
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin/dashboard" element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } />
                  
                  {/* Catch-all route - must be last */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
              <Footer />
              <Toaster />
            </BrowserRouter>
          </div>
        </AuthProvider>
      </BookmarksProvider>
    </ThemeProvider>
  );
}

export default App;
